import React, { useState, useEffect } from 'react';
import './App.css';
import { trackEvent } from './analytics';

function SubmissionPage() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        instagram: '',
        track_name: '',
        message: '',
        link: '',
        requested_price: '0',
        file: null
    });
    const [status, setStatus] = useState('');

    useEffect(() => {
        trackEvent('page_view', 'submission_page');
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setFormData(prev => ({ ...prev, file: e.target.files[0] }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('Submitting...');

        const data = new FormData();
        Object.keys(formData).forEach(key => {
            if (formData[key] !== null) {
                data.append(key, formData[key]);
            }
        });

        try {
            const response = await fetch('/api/submissions/submit/', {
                method: 'POST',
                body: data,
            });

            if (response.ok) {
                trackEvent('form_interaction', 'submission_success');
                setStatus('Submission successful! We will get back to you soon.');
                setFormData({
                    name: '',
                    email: '',
                    instagram: '',
                    track_name: '', // Added track_name to reset state
                    message: '',
                    link: '',
                    requested_price: '0',
                    file: null
                });
            } else {
                const result = await response.json();
                console.error('Error:', result);
                setStatus('Submission failed. Please try again.');
            }
        } catch (error) {
            console.error('Error:', error);
            setStatus('An error occurred. Please try again later.');
        }
    };

    return (
        <div className="submission-container">
            <h1>Submit Your Track</h1>
            <p className="submission-intro">Send us your demos or instrumentals. We review every submission.</p>

            <form onSubmit={handleSubmit} className="submission-form">
                <div className="form-group">
                    <label htmlFor="name">Artist / Producer Name *</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Your Stage Name"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="track_name">Track Name *</label>
                    <input
                        type="text"
                        id="track_name"
                        name="track_name"
                        value={formData.track_name}
                        onChange={handleChange}
                        required
                        placeholder="Name of your instrumental"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="name@example.com"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="instagram">Instagram Handle</label>
                    <input
                        type="text"
                        id="instagram"
                        name="instagram"
                        value={formData.instagram}
                        onChange={handleChange}
                        placeholder="@yourhandle"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="requested_price">Requested Price ($0 - $100)</label>
                    <select
                        id="requested_price"
                        name="requested_price"
                        value={formData.requested_price}
                        onChange={handleChange}
                        className="price-select"
                    >
                        {Array.from({ length: 21 }, (_, i) => i * 5).map(price => (
                            <option key={price} value={price}>${price}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="link">Link to Track (Spotify, SoundCloud, Drive, etc.)</label>
                    <input
                        type="url"
                        id="link"
                        name="link"
                        value={formData.link}
                        onChange={handleChange}
                        placeholder="https://..."
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="file">Or Upload File (Up to 10MB)</label>
                    <input
                        type="file"
                        id="file"
                        name="file"
                        onChange={handleFileChange}
                        accept="audio/*,.mp3,.wav"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="message">Message / Description *</label>
                    <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        placeholder="Tell us about this track..."
                        rows="4"
                    ></textarea>
                </div>

                <button type="submit" className="submit-btn" disabled={status === 'Submitting...'}>
                    {status === 'Submitting...' ? 'Sending...' : 'Submit Track'}
                </button>

                {status && <p className={`status-message ${status.includes('failed') || status.includes('error') ? 'error' : 'success'}`}>{status}</p>}
            </form>
        </div>
    );
}

export default SubmissionPage;
